<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZGwIwG/tc-custom/9781455611881.jpg?1718183632271" alt="This image is the cover for the book Shepherd of The Hills, Pelican Pouch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shepherd of The Hills, Pelican Pouch
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this classic Christian Western novel, a stranger brings a message of forgiveness to a remote community in the Ozark mountains.</b><br/>  <br/><i>The Shepherd of the Hills </i>tells the classic tale of a stranger who takes the Old Trail deep into the Ozark mountains, many miles from civilization. Learned yet melancholy, he spends his days tending local sheep. And though he lives apart from the townsfolk of Mutton Hollow, he is a friend to one and all. As the story of his tragic past comes to light, so do the lessons of grace and forgiveness bestowed upon us all by the true shepherd.<br/>  <br/> First published in 1907, <i>The Shepherd of the Hills</i> became an instant bestseller and was later adapted into a classic film starring John Wayne and Harry Carey. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harold Bell Wright
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A.L. Burt Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f5b9866e